// BaseNode.js

import { Handle, Position } from 'reactflow';

export const BaseNode = ({ id, title, children, handles = [], style = {} }) => {
    return (
        <div className="node-container" style={{ width: style.width || 200, ...style }}>
            {/* Render Handles */}
            {handles.map((handle, index) => (
                <Handle
                    key={`${id}-handle-${index}`}
                    type={handle.type}
                    position={handle.position}
                    id={handle.id}
                    style={handle.style || {}}
                />
            ))}

            {/* Node Title */}
            <div className="node-header">
                <span>{title}</span>
            </div>

            {/* Node Content */}
            <div className="node-content">
                {children}
            </div>
        </div>
    );
};
